"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgAddGameToAllCmsGameSetListsCtl = /** @class */ (function (_super) {
    __extends(DlgAddGameToAllCmsGameSetListsCtl, _super);
    function DlgAddGameToAllCmsGameSetListsCtl() {
        return _super.call(this, true) || this;
    }
    DlgAddGameToAllCmsGameSetListsCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            dialogTitle: "",
            visible: false,
            onNo: null
        };
    };
    DlgAddGameToAllCmsGameSetListsCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgAddGameToAllCmsGameSetListsCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgAddGameToAllCmsGameSetListsCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgAddGameToAllCmsGameSetListsCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgAddGameToAllCmsGameSetListsCtl.prototype.SetOnYesClick = function (callback, forceUpdate) {
        this.DATA.onYes = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgAddGameToAllCmsGameSetListsCtl.prototype.GetOnYesClick = function () {
        return this.DATA.onYes;
    };
    DlgAddGameToAllCmsGameSetListsCtl.prototype.SetOnNoClick = function (callback, forceUpdate) {
        this.DATA.onNo = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgAddGameToAllCmsGameSetListsCtl.prototype.GetOnNoClick = function () {
        return this.DATA.onNo;
    };
    DlgAddGameToAllCmsGameSetListsCtl.prototype.SetDialogTitle = function (title, forceUpdate) {
        this.DATA.dialogTitle = title;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgAddGameToAllCmsGameSetListsCtl.prototype.GetDialogTitle = function () {
        return this.DATA.dialogTitle;
    };
    return DlgAddGameToAllCmsGameSetListsCtl;
}(BaseController_1.BaseController));
exports.DlgAddGameToAllCmsGameSetListsCtl = DlgAddGameToAllCmsGameSetListsCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgAddGameToAllCmsGameSetListsCtl.ts
// module id = 914
// module chunks = 0